import { Component, OnInit, effect, signal } from '@angular/core';
import proj4 from "proj4";
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { register } from "ol/proj/proj4";
import OSM from 'ol/source/OSM';
import { SitePolygonLayer } from 'src/app/components/carte/layers/SitePolygonLayer';
import { DxfEntityWithColor } from 'src/app/services/dxf-service.service';

import { DxfServiceService } from 'src/app/services/dxf-service.service';
import { SitesService } from 'src/app/services/sites.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { SitePolygoneDto } from 'src/app/bo/site/sitePolygone';
import { transform } from 'ol/proj';

class file{
  name: string;
  color: string;
}

@Component({
  selector: 'app-dxf-management',
  templateUrl: './dxf-management.component.html',
  styleUrls: ['./dxf-management.component.scss'],
  standalone: false
})
export class DxfManagementComponent implements OnInit {

  protected files = signal<SitePolygoneDto[]>([]);

  private fileContents: { [key: string]: any } = {}; // Dictionary to store file name and parsed content
  private tempFileContent : any = null;
  private rawDxfContent = ''; // Store raw DXF file content for compression
  private newLayerBeingImported: VectorLayer<VectorSource> | null = null;
  private siteId = 0;
  private sitePolygonLayer: SitePolygonLayer;
  protected map: Map;
  protected epsg = 4326;
  protected isAddButtonDisabled = signal(false);
  protected isNewRowVisible = signal(false);
  protected saveable = signal(false);
  newFileName = '';
  newFileColor = '#000000';

  constructor(private readonly dxfService: DxfServiceService,
    private readonly siteService:SitesService,
    private readonly userService: UtilisateurService) {
    effect(() => {
      const site = this.userService.currentSite();
      if (!site) return;
      this.siteId = site.siteId;
      this.epsg = Number(site.epsg);
      this.onEpsgChange();
      // Reload polygones list when site changes after the component is mounted
      // (skipped on first init because the map doesn't exist yet — ngOnInit handles it).
      // loadSitePolygones now replaces (set) instead of appending, so no duplicates.
      if (this.map) {
        this.loadSitePolygones();
      }
    });
  }


  ngOnInit(): void {
    this.initMap();
    this.initEpsg();

    
    this.loadSitePolygones();
    if (this.sitePolygonLayer) {
      this.sitePolygonLayer.changeSite(this.siteId, this.epsg);
    }
  }


  private initEpsg(){
    if(this.userService.currentSite() !== null){
      this.epsg = Number(this.userService.currentSite()?.epsg);
      this.siteId = this.userService.currentSite()?.siteId;
      this.onEpsgChange();
    }
  }

// ...existing code...

    private initMap() {
      let center = [0, 0];
      let zoom = 2;

      // Utilise les coordonnées X/Y du site si elles existent
      if (this.userService.currentSite()) {
        const site = this.userService.currentSite();
        if (site.coordX !== undefined && site.coordY !== undefined) {
          // Transforme les coordonnées du site (EPSG du site) vers EPSG:3857 pour la carte
          center = transform(
            [site.coordX, site.coordY],
            `EPSG:${this.epsg}`,
            'EPSG:3857'
          );
          zoom = 15;
        }
      }

      this.map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center: center,
          zoom: zoom,
        }),
      });
    }
  protected deleteFile(index: number, dto: SitePolygoneDto): void {
    this.dxfService.deleteSitePolygone(this.siteId, dto.id).then(res => {
      this.files.update(f => f.filter((_, i) => i !== index));
    })
    .catch(err => {
      console.log(err);
    });
  }
  protected addFile(event: Event): void {

    this.removeImportedLayer();

    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
     this.newFileName = file.name;
      reader.onload = (e) => {
        const content = e.target?.result;

        // Store the raw DXF content for compression
        this.rawDxfContent = content as string;
        
        this.tempFileContent = this.dxfService.parseDxfFile(content as string);
        this.fileContents[file.name] = this.tempFileContent;

        this.loadEntity(this.tempFileContent);
      };
      reader.readAsText(file);
    }
  }

  protected onEpsgChange(){
    this.siteService.getEpsgProjString(this.epsg).then(projString => {
      console.log(projString);
      if(projString && projString.length >0){
        proj4.defs(`EPSG:${this.epsg}`, projString);
        register(proj4);

        this.removeImportedLayer();
        this.loadEntity(this.tempFileContent);
      }
    })
    .catch(err => {
      console.log(err);
    });
  }

  private loadEntity(entities: DxfEntityWithColor[]){
    if(entities === null || entities ===undefined|| entities.length === 0){
      return;
    } 

    // Use the service to create the vector layer
    this.newLayerBeingImported = this.dxfService.createVectorLayer(entities, this.epsg, this.newFileColor);

    if(null !== this.map){
      this.map.addLayer(this.newLayerBeingImported);
      this.saveable.set(true);
    }

    const vectorSource = this.newLayerBeingImported.getSource();
    if (vectorSource) {
      this.centerView(vectorSource);
    }
  }

  private loadSitePolygones(){
    const requestedSiteId = this.siteId;
    this.dxfService.loadSitepolygones(requestedSiteId).then(polygones => {
      // Ignore stale responses if the user has switched to another site in the meantime
      if (this.siteId !== requestedSiteId) return;
      this.files.set(polygones);
    })
    if (!this.sitePolygonLayer && this.map) {
    // Instancie SitePolygonLayer si besoin
    this.sitePolygonLayer = new SitePolygonLayer(
      this.dxfService,
      this.map,
      this.siteId,
      10, // zIndex, adapte si besoin
      this.epsg // Pass EPSG for DXF coordinate transformation
    );
  }
  if (this.sitePolygonLayer) {
    this.sitePolygonLayer.changeSite(this.siteId, this.epsg);
  }
  }

  protected centerView(vectorSource: VectorSource): void {
    const extent = vectorSource.getExtent();
    if (this.map) {
      this.map.getView().fit(extent, { size: this.map.getSize(), maxZoom: 18 });
    }
  }


  private removeImportedLayer(){
    this.map.removeLayer(this.newLayerBeingImported);
    this.saveable.set(false);
  }

  protected addNewRow(): void {
    this.isNewRowVisible.set(true);
    this.isAddButtonDisabled.set(true);
  }

  
  protected saveNewFile() {
    if (this.newFileName) {

      // Compress the raw DXF content
      const compressedDxf = this.dxfService.compressDxf(this.rawDxfContent);
      
      console.log('Original DXF size:', this.rawDxfContent.length, 'bytes');
      console.log('Compressed size:', compressedDxf.length, 'bytes');
      console.log('Compression ratio:', (compressedDxf.length / this.rawDxfContent.length * 100).toFixed(2) + '%');

      const polygonDto = new SitePolygoneDto(
        0, this.newFileColor, this.newFileName, true, compressedDxf, undefined);

        this.dxfService.saveToSitePolygone(this.siteId, polygonDto).then(() => {
        this.dxfService.loadSitepolygones(this.siteId).then(polygones => {
          this.files.set(polygones);
        });
        this.isNewRowVisible.set(false);
        this.isAddButtonDisabled.set(false);
        this.newFileName = '';
        this.newFileColor = '#000000';
      })
      .catch(err => {
        console.error('Error saving polygon:', err);
        console.error('Error details:', err.error);
        console.error('Status:', err.status);
      });
    }
  }

  /** L'aperçu suit la carte (DxfServiceService.createVectorLayer) : la couleur choisie ne colore qu'un DXF d'une seule polyligne. */
  protected OnImportColorChanged(){
    const features = this.newLayerBeingImported?.getSource()?.getFeatures() ?? [];
    if (!this.dxfService.usesChosenColor(features.length)) return;
    features.forEach(feature => {
      feature.set('color', this.newFileColor);
      feature.changed();
    });
  }

  protected OnLineColorChange(polygone: SitePolygoneDto, newColor: string) {
  polygone.color = newColor;

  // Met à jour la couleur sur la carte (voir réponse précédente)


  // Met à jour côté serveur
  this.dxfService.updateSitePolygone(this.siteId, polygone)
    .then(() => {
      // Recharge les polygones pour mettre à jour la couleur sur la carte
      if (this.sitePolygonLayer) {
        this.sitePolygonLayer.changeSite(this.siteId, this.epsg);
      }
    })
    .catch(err => {
      console.error('Erreur lors de la mise à jour du polygone :', err);
    });
}

}